const sgyRegulations = {
    baseYear: 2025,
    concessionalLimit: 30000,
    concessionalLimitYear: 2025,
    nonConcessionalLimit: 120000,
    maxSuperContBase: 260280,
    coContYear: 2025,
    coContThresholdMin: 45400,
    coContThresholdMax: 60400,
    coContMax: 500,
    coContRatePerc: 0.5,
    coContReductionRate: 0.03333,
    pensionAgeMax: 110,
    pensionSingleDollar: 1116.3,
    pensionCoupleDollar: 841.4,
    pensionSingleMinSupplement: 43.9,
    pensionSingleMaxSupplement: 81.6,
    pensionCoupleMinSupplement: 33.1,
    pensionCoupleMaxSupplement: 61.5,
    pensionSingleEnergySupplement: 14.1,
    pensionCoupleEnergySupplement: 10.6,
    pensionWorkBonus: 300,
    pensionThresholdHomeowner: 301750,
    pensionThresholdNonHomeowner: 543750,
    pensionRateOfReduction: 2.7372,
    pensionIncomeTestThreshold: 204,
    pensionIncomeTestRateOfReduction: 0.5,
    pensionCoupleThresholdHomeowner: 451500,
    pensionCoupleThresholdNonHomeowner: 693500,
    pensionCoupleRateOfReduction: 2.7372,
    pensionCoupleIncomeTestThreshold: 360,
    pensionCoupleIncomeTestRateOfReduction: 0.5,
    pensionDeemingThresholdSingle: 60400,
    pensionDeemingThresholdCouple: 100200,
    pensionDeemingRateBelowThreshold: 0.0025,
    //we are not considering the tier where in the couple none are retired
    pensionDeemingRateAboveThreshold: 0.0225,
    untaxedConcessionalLimit: 1780000,
    untaxedConcessionalLimitYear: 2025,
    litoLowerLimit: 37500,
    litoMiddleLimit: 45000,
    litoUpperLimit: 66667,
    litoMaxReturnOne: 700,
    litoMaxReturnTwo: 325,
    litoTaperRateOne: 0.05,
    litoTaperRateTwo: 0.015,
    medicareLevyLowerThreshold: 24276,
    medicareLevyUpperThreshold: 30345,
    medicareLevyTaper: 0.1,
    medicareLevy: 0.02,
    listoMaxIncome: 37000,
    listoTaxRate: 0.15,
    listoMaxRebate: 500,
    tbcBaseYear: 2025,
    gtbc: 1900000,
    ptbc: 1900000,
    contributionTaxRate: 0.15,
    contributionTaxRateMax: 0.3,
    contributionTaxThreshold: 250000,
    additionalTaxOnEarningsYear: 2026,
    additionalTaxOnEarnings: 0.15,
    additionalTaxOnEarningsThreshold: 3000000,

    /* Minimum Annual Pension Payment */
    pensionMinimumDrawdownArray: [
        [95, 0.14],
        [90, 0.11],
        [85, 0.09],
        [80, 0.07],
        [75, 0.06],
        [65, 0.05],
        [55, 0.04],
        [0, 0],
    ],

    /* Employer Super Guarantees Contributions */
    superGuaranteeContributionRatesArray: [
        [2021, 0.095],
        [2022, 0.1],
        [2023, 0.105],
        [2024, 0.11],
        [2025, 0.115],
        [2026, 0.12],
    ],

    /* LIFE EXPECTANCY (years until death)*/
    lifeExpectancyArray: [
        [80.76, 84.85],
        [80.05, 84.11],
        [79.07, 83.12],
        [78.08, 82.14],
        [77.09, 81.14],
        [76.1, 80.15],
        [75.11, 79.16],
        [74.11, 78.16],
        [73.12, 77.17],
        [72.12, 76.17],
        [71.13, 75.18],
        [70.14, 74.18],
        [69.14, 73.19],
        [68.15, 72.19],
        [67.16, 71.2],
        [66.17, 70.21],
        [65.18, 69.22],
        [64.2, 68.23],
        [63.23, 67.25],
        [62.26, 66.26],
        [61.29, 65.28],
        [60.32, 64.29],
        [59.36, 63.3],
        [58.39, 62.32],
        [57.43, 61.33],
        [56.46, 60.35],
        [55.5, 59.36],
        [54.53, 58.37],
        [53.57, 57.39],
        [52.61, 56.41],
        [51.65, 55.42],
        [50.68, 54.44],
        [49.72, 53.46],
        [48.77, 52.48],
        [47.81, 51.51],
        [46.85, 50.53],
        [45.9, 49.56],
        [44.95, 48.58],
        [44.0, 47.61],
        [43.05, 46.64],
        [42.1, 45.68],
        [41.16, 44.71],
        [40.22, 43.75],
        [39.29, 42.79],
        [38.35, 41.83],
        [37.43, 40.88],
        [36.5, 39.92],
        [35.58, 38.97],
        [34.66, 38.03],
        [33.75, 37.08],
        [32.84, 36.14],
        [31.93, 35.21],
        [31.03, 34.27],
        [30.13, 33.34],
        [29.24, 32.42],
        [28.35, 31.49],
        [27.47, 30.57],
        [26.6, 29.66],
        [25.73, 28.75],
        [24.87, 27.84],
        [24.02, 26.93],
        [23.17, 26.03],
        [22.33, 25.14],
        [21.5, 24.24],
        [20.67, 23.36],
        [19.86, 22.47],
        [19.04, 21.6],
        [18.24, 20.73],
        [17.45, 19.87],
        [16.67, 19.02],
        [15.9, 18.18],
        [15.14, 17.35],
        [14.39, 16.53],
        [13.66, 15.73],
        [12.95, 14.93],
        [12.25, 14.15],
        [11.57, 13.39],
        [10.9, 12.64],
        [10.25, 11.9],
        [9.63, 11.18],
        [9.02, 10.49],
        [8.44, 9.81],
        [7.89, 9.16],
        [7.36, 8.54],
        [6.86, 7.94],
        [6.39, 7.37],
        [5.95, 6.83],
        [5.54, 6.32],
        [5.16, 5.84],
        [4.81, 5.4],
        [4.5, 4.99],
        [4.22, 4.61],
        [3.96, 4.28],
        [3.72, 3.97],
        [3.5, 3.69],
        [3.29, 3.43],
        [3.11, 3.18],
        [2.93, 2.94],
        [2.77, 2.73],
        [2.62, 2.53],
        [2.49, 2.36],
    ],
    /* annual tax table */
    incomeTaxArray: [
        [18200, 0, 0, 0],
        [45000, 0.16, 0, 18200],
        [135000, 0.3, 4288, 45000],
        [190000, 0.37, 31288, 1350000],
        [999999999, 0.45, 51638, 190000],
    ],
    /* asfa retirement budgets */
    // September quarter 2024
    asfaRetirementBudgets: {
        singleModest: {
            housing: 124.78,
            energy: 33.77,
            food: 112.65,
            communications: 18.2,
            household: 39.65,
            clothing: 21.42,
            transport: 108.78,
            health: 57.72,
            leisure: 113.88,
            totals: {
                weekly: 631,
                fortnightly: 1262,
                monthly: 2744.17,
                yearly: 32930,
            },
        },
        singleComfortable: {
            housing: 146.8,
            energy: 42.78,
            food: 145.65,
            communications: 22.76,
            household: 86.6,
            clothing: 28.61,
            transport: 177.7,
            health: 117.29,
            leisure: 224.42,
            totals: {
                weekly: 993,
                fortnightly: 1986,
                monthly: 4317.84,
                yearly: 51814,
            },
        },
        coupleModest: {
            housing: 141.02,
            energy: 45.36,
            food: 208.85,
            communications: 20.5,
            household: 46.72,
            clothing: 40.71,
            transport: 115.91,
            health: 111.71,
            leisure: 178.71,
            totals: {
                weekly: 909,
                fortnightly: 1818,
                monthly: 3956.25,
                yearly: 47475,
            },
        },
        coupleComfortable: {
            housing: 153.26,
            energy: 53.06,
            food: 253.15,
            communications: 29.62,
            household: 107.39,
            clothing: 53.28,
            transport: 192.52,
            health: 219.69,
            leisure: 337.1,
            totals: {
                weekly: 1399,
                fortnightly: 2798,
                monthly: 6085.92,
                yearly: 73031,
            },
        },
    },
};

module.exports = {
    sgyRegulations,
};
